var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('vue-title', {
    attrs: {
      "title": "Register - Your Indoor Cycling Solution"
    }
  }), _c('section', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-8 mx-auto"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('h3', [_vm._v("Create New Account")]), _c('p', {
    staticStyle: {
      "text-transform": "uppercase",
      "font-weight": "600",
      "margin-top": "10px"
    }
  }, [_vm._v(" Stunning Maps, World-Class Workouts, Daily Events & Prize Money Races Free-To-Ride, No Subscription Required ")]), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.registerHandler.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l(_vm.schema, function (field, i) {
    return _c('div', {
      key: i,
      class: field.colClass
    }, [_c('div', {
      staticClass: "form-group"
    }, [field.type !== 'consent' ? _c('label', {
      domProps: {
        "textContent": _vm._s(field.label)
      }
    }) : _vm._e(), field.type === 'select' ? [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      on: {
        "change": function ($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
            return o.selected;
          }).map(function (o) {
            var val = "_value" in o ? o._value : o.value;
            return val;
          });
          _vm.$set(_vm.form, field.model, $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
        }
      }
    }, _vm._l(_vm.dropdowns[field.options], function (dd, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": dd.Id
        }
      }, [_vm._v(" " + _vm._s(dd.Name) + " ")]);
    }), 0)] : field.type === 'date' ? [field.type === 'checkbox' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "max": _vm.giveMaxRangeForDate(),
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.form[field.model]) ? _vm._i(_vm.form[field.model], null) > -1 : _vm.form[field.model]
      },
      on: {
        "change": function ($event) {
          var $$a = _vm.form[field.model],
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.form, field.model, $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.form, field.model, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.form, field.model, $$c);
          }
        }
      }
    }) : field.type === 'radio' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "max": _vm.giveMaxRangeForDate(),
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(_vm.form[field.model], null)
      },
      on: {
        "change": function ($event) {
          return _vm.$set(_vm.form, field.model, null);
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "max": _vm.giveMaxRangeForDate(),
        "type": field.type
      },
      domProps: {
        "value": _vm.form[field.model]
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, field.model, $event.target.value);
        }
      }
    })] : field.type === 'number' ? [field.type === 'checkbox' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "step": ".01",
        "min": field.min,
        "max": field.max,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.form[field.model]) ? _vm._i(_vm.form[field.model], null) > -1 : _vm.form[field.model]
      },
      on: {
        "change": function ($event) {
          var $$a = _vm.form[field.model],
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.form, field.model, $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.form, field.model, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.form, field.model, $$c);
          }
        }
      }
    }) : field.type === 'radio' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "step": ".01",
        "min": field.min,
        "max": field.max,
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(_vm.form[field.model], null)
      },
      on: {
        "change": function ($event) {
          return _vm.$set(_vm.form, field.model, null);
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "step": ".01",
        "min": field.min,
        "max": field.max,
        "type": field.type
      },
      domProps: {
        "value": _vm.form[field.model]
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, field.model, $event.target.value);
        }
      }
    })] : field.type === 'consent' ? [_c('div', {
      staticClass: "form-check"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-check-input",
      attrs: {
        "oninvalid": "this.setCustomValidity('You must agree to the terms and conditions to register')",
        "onchange": "this.setCustomValidity('')",
        "required": field.validation['required'],
        "type": "checkbox",
        "id": field.id
      },
      domProps: {
        "checked": Array.isArray(_vm.form[field.model]) ? _vm._i(_vm.form[field.model], null) > -1 : _vm.form[field.model]
      },
      on: {
        "change": function ($event) {
          var $$a = _vm.form[field.model],
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.form, field.model, $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.form, field.model, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.form, field.model, $$c);
          }
        }
      }
    }), _c('label', {
      staticClass: "form-check-label",
      attrs: {
        "for": field.id
      },
      domProps: {
        "innerHTML": _vm._s(field.consent_text)
      }
    })])] : field.model === 'firstname' || field.model === 'lastname' ? [field.type === 'checkbox' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.form[field.model]) ? _vm._i(_vm.form[field.model], null) > -1 : _vm.form[field.model]
      },
      on: {
        "blur": function ($event) {
          var _vm$$v$form$field$mod;
          (_vm$$v$form$field$mod = _vm.$v.form[field.model]) === null || _vm$$v$form$field$mod === void 0 ? void 0 : _vm$$v$form$field$mod.$touch;
        },
        "change": function ($event) {
          var $$a = _vm.form[field.model],
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.form, field.model, $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.form, field.model, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.form, field.model, $$c);
          }
        }
      }
    }) : field.type === 'radio' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(_vm.form[field.model], null)
      },
      on: {
        "blur": function ($event) {
          var _vm$$v$form$field$mod2;
          (_vm$$v$form$field$mod2 = _vm.$v.form[field.model]) === null || _vm$$v$form$field$mod2 === void 0 ? void 0 : _vm$$v$form$field$mod2.$touch;
        },
        "change": function ($event) {
          return _vm.$set(_vm.form, field.model, null);
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "type": field.type
      },
      domProps: {
        "value": _vm.form[field.model]
      },
      on: {
        "blur": function ($event) {
          var _vm$$v$form$field$mod3;
          (_vm$$v$form$field$mod3 = _vm.$v.form[field.model]) === null || _vm$$v$form$field$mod3 === void 0 ? void 0 : _vm$$v$form$field$mod3.$touch;
        },
        "input": function ($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, field.model, $event.target.value);
        }
      }
    }), !_vm.$v.form[field.model].validName ? _c('div', {
      staticClass: "text-danger",
      staticStyle: {
        "margin-top": "2%"
      }
    }, [_vm._v(" Non latin characters are not supported ")]) : _vm._e()] : [field.type === 'checkbox' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.form[field.model]) ? _vm._i(_vm.form[field.model], null) > -1 : _vm.form[field.model]
      },
      on: {
        "change": function ($event) {
          var $$a = _vm.form[field.model],
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.form, field.model, $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.form, field.model, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.form, field.model, $$c);
          }
        }
      }
    }) : field.type === 'radio' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(_vm.form[field.model], null)
      },
      on: {
        "change": function ($event) {
          return _vm.$set(_vm.form, field.model, null);
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "type": field.type
      },
      domProps: {
        "value": _vm.form[field.model]
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, field.model, $event.target.value);
        }
      }
    })], _vm.submitted && _vm.getError(field.model) ? _c('div', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(field.label) + " is required. ")]) : _vm._e()], 2)]);
  }), _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.weightError || _vm.heightError) + " ")])], 2), _c('div', {
    staticClass: "form-group"
  }, [_c('re-captcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.sitekey
    },
    on: {
      "change": _vm.onRecaptchaChange
    }
  })], 1), _c('button', {
    staticClass: "btn-universal",
    class: {
      'btn-disabled': !_vm.recaptchaVerified
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.recaptchaVerified
    }
  }, [_vm._v(" Submit ")]), _c('button', {
    staticClass: "btn-universal btn-register-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('login');
      }
    }
  }, [_vm._v(" Cancel ")])]), _vm.formErrors.length > 0 ? _c('div', {
    staticClass: "ml-5 mr-5 mt-3 text-left p-2 pl-3 rounded"
  }, _vm._l(_vm.formErrors, function (error, e) {
    return _c('p', {
      key: e,
      staticClass: "m-0 text-danger"
    }, [_vm._v(" " + _vm._s(error) + " ")]);
  }), 0) : _vm._e()])])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }